var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-responsive',[(_vm.theme === 1)?_c('detail-theme0001',{attrs:{"detail-product":_vm.detailproduct}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }